<div class="">
  <div
    *ngIf="isLoading"
    class="flex justify-center flex-col items-center py-10"
  >
    <div
      class="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"
    ></div>
    <p class="text-lg text-gray-500 font-medium pt-5">Pensando empleos para ti</p>
  </div>
  <div
    *ngIf="!isLoading && jobs.length === 0"
    class="text-center py-10 text-gray-500"
  >
    <p class="text-lg font-medium">
      No hay trabajos disponibles en este momento
    </p>
    <p class="text-sm">Vuelve más tarde para ver nuevas ofertas laborales</p>
  </div>
  <ng-container *ngIf="!isLoading && jobs.length > 0">
    <div class="flex flex-col gap-4">
      <app-job-card
        *ngFor="let job of jobs; trackBy: trackById"
        [job]="job"
      ></app-job-card>
    </div>
  </ng-container>
</div>
